// removed by extract-text-webpack-plugin
module.exports = {"courierAddressModal":"qempo_CourierAddressModal_courierAddressModal-vkokMlH","title":"qempo_CourierAddressModal_title-1VRKLPC","text":"qempo_CourierAddressModal_text-mxGM5wS","itemsSubtitle":"qempo_CourierAddressModal_itemsSubtitle-3VddIcH","itemLink":"qempo_CourierAddressModal_itemLink-2lH8xi9","button":"qempo_CourierAddressModal_button-rhN5-mw"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/new-order/CheckoutStep/components/CourierAddressModal/CourierAddressModal.scss
// module id = 1738
// module chunks = 0